import React, { createContext, ReactNode, useContext } from 'react';
import { TakeoverId, TakeoverState } from '../../hooks/useTakeover';

export type OpenTakeover = (id: TakeoverId, props?: Record<string, any>) => void;

interface TakeoverContextType {
  openTakeover: OpenTakeover;
  closeTakeover: () => void;
  closeAllTakeovers: () => void;
  takeoverState: TakeoverState;
}

const TakeoverContext = createContext<TakeoverContextType | undefined>(undefined);

export const useTakeoverContext = () => {
  const context = useContext(TakeoverContext);
  if (!context) {
    throw new Error('useTakeoverContext must be used within a TakeoverContextProvider');
  }
  return context;
};

interface TakeoverContextProviderProps {
  children: ReactNode;
  openTakeover: OpenTakeover;
  closeTakeover: () => void;
  closeAllTakeovers: () => void;
  takeoverState: TakeoverState;
}

export const TakeoverContextProvider: React.FC<TakeoverContextProviderProps> = ({
  children,
  openTakeover,
  closeTakeover,
  closeAllTakeovers,
  takeoverState,
}) => (
  <TakeoverContext.Provider value={{ openTakeover, closeTakeover, takeoverState, closeAllTakeovers }}>
    {children}
  </TakeoverContext.Provider>
);
